// Bilingual UI + content strings for Golden Tulip Digital Concierge

export const translations = {
  id: {
    // Welcome
    tagline: "Selamat datang, kami telah menanti kedatangan Anda.",
    titleLabel: "Sapaan",
    namePlaceholder: "Masukkan nama Anda",
    roomPlaceholder: "Contoh: 301",
    start: "Mulai",
    footer: "Golden Tulip Holland Resort Batu",

    // Nav
    nav: { dashboard: "Home", ai: "AI Chat", operator: "Operator", menu: "Menu" },

    // Dashboard
    greeting: "Halo, ",
    roomInfo: (room) => `Kamar ${room} · Golden Tulip Holland Resort`,
    quickInfo: [
      { icon: "Clock", text: "Check-out: 12:00 WIB" },
      { icon: "Wifi", text: "WiFi: GT_Holland_Guest" },
      { icon: "Siren", text: "Darurat: ext. 100" },
    ],
    menuLabels: {
      ai: "Tanya AI Concierge",
      operator: "Chat Operator",
      menu: "Menu & Room Service",
      promo: "Promo & Info Hotel",
      call: "Hubungi Resepsionis",
      feedback: "Beri Feedback",
    },
    welcomeTitle: "Selamat Datang di Golden Tulip",
    welcomeDesc:
      "Resort bintang 5 di ketinggian 950 mdpl dengan pemandangan Gunung Panderman & Arjuna. Nikmati pengalaman menginap terbaik Anda.",
    viewInfo: "Lihat Info Lengkap",
    logoutConfirm: "Keluar dan ganti identitas tamu?",

    // AI Chat
    aiTitle: "AI Concierge",
    poweredBy: "✨ Powered by AI",
    aiWelcome: (name) =>
      `Halo ${name}! 👋 Saya AI Concierge Golden Tulip Holland Resort. Saya bisa bantu Anda dengan informasi seputar fasilitas hotel, restoran, spa, tempat wisata sekitar, dan lainnya. Silakan tanya apa saja!`,
    suggestions: [
      "Fasilitas hotel apa saja?",
      "Restoran & jam buka",
      "Wisata sekitar hotel",
      "Layanan spa",
      "Room service",
    ],
    askPlaceholder: "Tanya apa saja...",
    aiTyping: "AI sedang mengetik...",
    aiError: "Maaf, koneksi bermasalah. Silakan coba lagi 😊",

    // Operator
    opTitle: "Chat Operator",
    online: "Online",
    opWelcome: (name, room) =>
      `Selamat datang di layanan Chat Operator, ${name} (Kamar ${room}). Tim kami siap membantu Anda. Silakan sampaikan kebutuhan Anda 😊`,
    opPlaceholder: "Tulis pesan untuk operator...",
    opTyping: "Operator sedang mengetik...",

    // Menu
    menuTitle: "Menu & Room Service",
    categories: [
      { key: "all", label: "Semua" },
      { key: "food", label: "Makanan" },
      { key: "drink", label: "Minuman" },
      { key: "snack", label: "Snack & Dessert" },
    ],
    menuFooter1: "Untuk memesan, hubungi Room Service di ",
    ext101: "ext. 101",
    chatToOrder: "Chat Operator untuk Pesan",
    priceNote: "Menu dan harga dapat berubah sewaktu-waktu",

    // Promo
    promoTitle: "Promo & Info",
    secPromo: "Promo Aktif",
    secFacilities: "Fasilitas Hotel",
    secInfo: "Info Penting",
    facilities: [
      { icon: "Waves", label: "Kolam Renang (Outdoor & Indoor)" },
      { icon: "Sparkles", label: "Spa & Wellness" },
      { icon: "Dumbbell", label: "Fitness Center 24 Jam" },
      { icon: "Baby", label: "Kids Club & Playground" },
      { icon: "Circle", label: "Billiard Room" },
      { icon: "Bike", label: "Rental Sepeda & E-Scooter" },
      { icon: "Briefcase", label: "Meeting Room (6 ruang)" },
      { icon: "Shirt", label: "Laundry Service" },
    ],
    importantInfo: [
      { icon: "Clock", text: "Check-in: 15:00 WIB | Check-out: 12:00 WIB" },
      { icon: "Clock", text: "Late check-out bisa diatur via resepsionis" },
      { icon: "Wifi", text: "WiFi: GT_Holland_Guest" },
      { icon: "Phone", text: "Resepsionis: +62 341 330 2000" },
      { icon: "Siren", text: "Darurat: ext. 100" },
      { icon: "Luggage", text: "Penitipan bagasi tersedia di front desk" },
    ],

    // Feedback
    fbTitle: "Beri Feedback",
    fbQuestion: "Bagaimana pengalaman Anda menginap di Golden Tulip?",
    ratingLabels: { 1: "Sangat Kurang 😞", 2: "Kurang 😕", 3: "Cukup 🙂", 4: "Baik 😊", 5: "Luar Biasa 🤩" },
    fbPlaceholder: "Ceritakan pengalaman Anda (opsional)",
    fbSubmit: "Kirim Feedback",
    fbSending: "Mengirim...",
    fbError: "Gagal mengirim feedback. Silakan coba lagi.",
    fbThanksTitle: "Terima kasih!",
    fbThanksMsg: (name) => `Terima kasih atas feedback Anda, ${name}! 🙏 Masukan Anda sangat berarti bagi kami.`,

    // Staff
    staffTitle: "Dashboard Staf",
    staffSubtitle: "Golden Tulip Holland Resort Batu",
    staffFeedbackTab: "Feedback Tamu",
    staffRequestsTab: "Permintaan Operator",
    staffEmptyFeedback: "Belum ada feedback dari tamu.",
    staffEmptyRequests: "Belum ada permintaan dari tamu.",
    staffEmptyUnresolved: "Semua permintaan sudah ditangani. 🎉",
    staffRefresh: "Muat ulang",
    staffRoom: "Kamar",
    staffAvg: "Rata-rata",
    staffTotal: "Total",
    staffPending: "Belum Ditangani",
    staffGateTitle: "Akses Staf",
    staffGateSubtitle: "Masukkan kata sandi staf untuk melanjutkan.",
    staffGatePlaceholder: "Kata sandi",
    staffGateBtn: "Buka",
    staffGateError: "Kata sandi salah",
    staffChecking: "Memeriksa akses...",
    staffLogout: "Kunci",
    reqNew: "Baru",
    reqMarkDone: "Tandai Selesai",
    reqReopen: "Buka Lagi",
    reqResolvedBy: (name) => `Diselesaikan oleh ${name}`,
    reqReplyThread: "Balas",
    reqCloseThread: "Tutup",
    reqReplyPlaceholder: "Tulis balasan untuk tamu...",
    staffNamePrompt: "Siapa nama Anda? (ditampilkan saat menandai permintaan selesai)",
    staffUnresolvedOnly: "Belum ditangani saja",

    // Content management (promo & menu admin)
    staffContentTab: "Kelola Konten",
    contentPromoSubtab: "Promo",
    contentMenuSubtab: "Menu",
    addPromo: "Tambah Promo",
    addMenuItem: "Tambah Menu",
    edit: "Edit",
    delete: "Hapus",
    save: "Simpan",
    confirmDelete: "Yakin mau hapus ini?",
    fieldEmoji: "Emoji (contoh: 🧖)",
    fieldTitleId: "Judul (Bahasa Indonesia)",
    fieldTitleEn: "Judul (English)",
    fieldDescId: "Deskripsi (Bahasa Indonesia)",
    fieldDescEn: "Deskripsi (English)",
    fieldName: "Nama menu",
    fieldPrice: "Harga (Rp)",
    fieldActive: "Aktif (tampil ke tamu)",
    fieldInactive: "Nonaktif",
    catFood: "Makanan",
    catDrink: "Minuman",
    catSnack: "Snack & Dessert",
  },

  en: {
    tagline: "Welcome, we've been expecting you.",
    titleLabel: "Title",
    namePlaceholder: "Enter your name",
    roomPlaceholder: "e.g. 301",
    start: "Start",
    footer: "Golden Tulip Holland Resort Batu",

    nav: { dashboard: "Home", ai: "AI Chat", operator: "Operator", menu: "Menu" },

    greeting: "Hello, ",
    roomInfo: (room) => `Room ${room} · Golden Tulip Holland Resort`,
    quickInfo: [
      { icon: "Clock", text: "Check-out: 12:00 WIB" },
      { icon: "Wifi", text: "WiFi: GT_Holland_Guest" },
      { icon: "Siren", text: "Emergency: ext. 100" },
    ],
    menuLabels: {
      ai: "Ask AI Concierge",
      operator: "Chat Operator",
      menu: "Menu & Room Service",
      promo: "Promos & Hotel Info",
      call: "Call Reception",
      feedback: "Give Feedback",
    },
    welcomeTitle: "Welcome to Golden Tulip",
    welcomeDesc:
      "A 5-star resort at 950m above sea level with views of Mount Panderman & Arjuna. Enjoy your finest stay.",
    viewInfo: "View Full Info",
    logoutConfirm: "Log out and change guest identity?",

    aiTitle: "AI Concierge",
    poweredBy: "✨ Powered by AI",
    aiWelcome: (name) =>
      `Hello ${name}! 👋 I'm the AI Concierge of Golden Tulip Holland Resort. I can help you with information about hotel facilities, restaurants, spa, nearby attractions, and more. Feel free to ask anything!`,
    suggestions: [
      "What facilities are available?",
      "Restaurants & opening hours",
      "Attractions nearby",
      "Spa services",
      "Room service",
    ],
    askPlaceholder: "Ask me anything...",
    aiTyping: "AI is typing...",
    aiError: "Sorry, connection issue. Please try again 😊",

    opTitle: "Chat Operator",
    online: "Online",
    opWelcome: (name, room) =>
      `Welcome to the Chat Operator service, ${name} (Room ${room}). Our team is ready to assist you. Please let us know what you need 😊`,
    opPlaceholder: "Type a message to the operator...",
    opTyping: "Operator is typing...",

    menuTitle: "Menu & Room Service",
    categories: [
      { key: "all", label: "All" },
      { key: "food", label: "Food" },
      { key: "drink", label: "Drinks" },
      { key: "snack", label: "Snacks & Dessert" },
    ],
    menuFooter1: "To order, contact Room Service at ",
    ext101: "ext. 101",
    chatToOrder: "Chat Operator to Order",
    priceNote: "Menu and prices are subject to change",

    promoTitle: "Promos & Info",
    secPromo: "Active Promos",
    secFacilities: "Hotel Facilities",
    secInfo: "Important Info",
    facilities: [
      { icon: "Waves", label: "Swimming Pool (Outdoor & Indoor)" },
      { icon: "Sparkles", label: "Spa & Wellness" },
      { icon: "Dumbbell", label: "24-Hour Fitness Center" },
      { icon: "Baby", label: "Kids Club & Playground" },
      { icon: "Circle", label: "Billiard Room" },
      { icon: "Bike", label: "Bicycle & E-Scooter Rental" },
      { icon: "Briefcase", label: "Meeting Rooms (6 rooms)" },
      { icon: "Shirt", label: "Laundry Service" },
    ],
    importantInfo: [
      { icon: "Clock", text: "Check-in: 15:00 WIB | Check-out: 12:00 WIB" },
      { icon: "Clock", text: "Late check-out can be arranged via reception" },
      { icon: "Wifi", text: "WiFi: GT_Holland_Guest" },
      { icon: "Phone", text: "Reception: +62 341 330 2000" },
      { icon: "Siren", text: "Emergency: ext. 100" },
      { icon: "Luggage", text: "Luggage storage available at front desk" },
    ],

    fbTitle: "Give Feedback",
    fbQuestion: "How was your stay at Golden Tulip?",
    ratingLabels: { 1: "Very Poor 😞", 2: "Poor 😕", 3: "Okay 🙂", 4: "Good 😊", 5: "Amazing 🤩" },
    fbPlaceholder: "Tell us about your experience (optional)",
    fbSubmit: "Submit Feedback",
    fbSending: "Sending...",
    fbError: "Failed to submit feedback. Please try again.",
    fbThanksTitle: "Thank you!",
    fbThanksMsg: (name) => `Thank you for your feedback, ${name}! 🙏 Your input means a lot to us.`,

    staffTitle: "Staff Dashboard",
    staffSubtitle: "Golden Tulip Holland Resort Batu",
    staffFeedbackTab: "Guest Feedback",
    staffRequestsTab: "Operator Requests",
    staffEmptyFeedback: "No guest feedback yet.",
    staffEmptyRequests: "No guest requests yet.",
    staffEmptyUnresolved: "All requests are handled. 🎉",
    staffRefresh: "Refresh",
    staffRoom: "Room",
    staffAvg: "Average",
    staffTotal: "Total",
    staffPending: "Pending",
    staffGateTitle: "Staff Access",
    staffGateSubtitle: "Enter the staff passcode to continue.",
    staffGatePlaceholder: "Passcode",
    staffGateBtn: "Unlock",
    staffGateError: "Incorrect passcode",
    staffChecking: "Checking access...",
    staffLogout: "Lock",
    reqNew: "New",
    reqMarkDone: "Mark Done",
    reqReopen: "Reopen",
    reqResolvedBy: (name) => `Resolved by ${name}`,
    reqReplyThread: "Reply",
    reqCloseThread: "Close",
    reqReplyPlaceholder: "Write a reply to the guest...",
    staffNamePrompt: "What's your name? (shown when you mark a request done)",
    staffUnresolvedOnly: "Unresolved only",

    // Content management (promo & menu admin)
    staffContentTab: "Manage Content",
    contentPromoSubtab: "Promo",
    contentMenuSubtab: "Menu",
    addPromo: "Add Promo",
    addMenuItem: "Add Menu Item",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    confirmDelete: "Are you sure you want to delete this?",
    fieldEmoji: "Emoji (e.g. 🧖)",
    fieldTitleId: "Title (Indonesian)",
    fieldTitleEn: "Title (English)",
    fieldDescId: "Description (Indonesian)",
    fieldDescEn: "Description (English)",
    fieldName: "Item name",
    fieldPrice: "Price (Rp)",
    fieldActive: "Active (shown to guests)",
    fieldInactive: "Inactive",
    catFood: "Food",
    catDrink: "Drinks",
    catSnack: "Snack & Dessert",
  },
};
